export default "__VITE_ASSET__Q_ccz87E__"